export default "__VITE_ASSET__ccySD_Ub__"